import { Reveal, SectionHead } from "./Reveal";
import { LABOUR_CODES, LABOUR_CODE_COVERAGE } from "@/data/content";
import { AlertTriangle, Check } from "lucide-react";

const LabourCodes = () => (
    <section id="labour-codes" className="py-24 sm:py-32 border-t border-white/10 bg-[#0D1730]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="New Labour Codes"
                title="New Labour Codes Compliance"
                sub="Support relating to the new Labour Codes — subject to the applicable rules, notifications and effective dates."
            />
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="labour-codes-grid">
                {LABOUR_CODES.map((c, i) => (
                    <Reveal key={c.name} delay={i * 0.08}>
                        <div className="h-full border border-white/10 bg-[#0A1128] p-7 hover:border-sky-400/40 transition-colors duration-300">
                            <span className="font-mono2 text-[10px] text-sky-500 tracking-widest">CODE {String(i + 1).padStart(2, "0")}</span>
                            <h3 className="mt-4 font-heading text-lg font-semibold text-white leading-snug">{c.name}</h3>
                            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <div className="mt-12 grid lg:grid-cols-2 gap-8">
                <Reveal>
                    <div className="border border-white/10 bg-[#0A1128] p-8">
                        <h3 className="font-heading text-lg font-semibold text-white">What we cover</h3>
                        <ul className="mt-5 grid sm:grid-cols-2 gap-x-6 gap-y-3" data-testid="labour-code-coverage-list">
                            {LABOUR_CODE_COVERAGE.map((item) => (
                                <li key={item} className="flex items-start gap-2.5 text-sm text-slate-300">
                                    <Check size={15} className="text-emerald-400 mt-0.5 shrink-0" />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="h-full border border-amber-400/30 bg-amber-400/5 p-8 flex gap-4" data-testid="labour-codes-notice">
                        <AlertTriangle size={22} className="text-amber-400 shrink-0 mt-1" />
                        <div>
                            <h3 className="font-heading text-base font-semibold text-amber-300">Important Notice</h3>
                            <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                                Applicability and compliance requirements are subject to the latest Central/State rules,
                                notifications and applicable provisions.
                            </p>
                            <a href="#contact" data-testid="labour-codes-cta" className="mt-5 inline-block text-sm font-semibold text-sky-300 hover:text-sky-200 transition-colors">
                                Talk to Our Compliance Team →
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default LabourCodes;
